import { useFormikContext } from 'formik';
import CheckboxGroupField from '../forms/checkbox-group-field';
import {
  getEventCategoryOptionsForType
} from '../../utils/event-categories';
import { eventTypes } from '../../utils/events';
import type { EventFormValues } from './form';

type Props = {
  disabled: boolean;
  forceTouched: boolean;
};

const EventFormCategories = ({ disabled, forceTouched }: Props) => {
  const {
    values: { eventType },
  } = useFormikContext<EventFormValues>();

  return (
    <CheckboxGroupField
      name="categoryIds"
      label={`${eventTypes[eventType].name} categories (optional)`}
      disabled={disabled}
      touched={forceTouched}
      options={getEventCategoryOptionsForType(eventType)}
    />
  );
};

export default EventFormCategories;
